import React from "react";
import * as Icons from "lucide-react";

export function EmptyState({ icon = "Inbox", title, description, action, testId }) {
  const Icon = Icons[icon] || Icons.Inbox;
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-[#D2D9E3] bg-white/50 px-6 py-14 text-center"
    >
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F4F6F9] text-[#AEB8C7]">
        <Icon size={26} strokeWidth={1.5} />
      </span>
      <h3 className="font-display text-lg font-semibold text-[#0B1729]">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-[#1E2D44]/55">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function ComingSoon({ label = "Coming soon" }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-[#E4E8EF] px-2.5 py-0.5 text-xs font-medium text-[#1E2D44]/60">
      <Icons.Clock size={12} /> {label}
    </span>
  );
}
